import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Sale01 from '../components/sale/Sale01';
import { landingApi } from '../api/landing-api';

const levelBadge = {
  BEGINNER: { label: 'Pemula', color: '#58bd7d', bg: 'rgba(88,189,125,0.1)' },
  INTERMEDIATE: { label: 'Menengah', color: '#0C8F86', bg: 'rgba(12,143,134,0.1)' },
  ADVANCED: { label: 'Mahir', color: '#d33535', bg: 'rgba(211,53,53,0.1)' },
};

function AcademyDetail() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const FE_WEB_URL = 'https://app.tradiora.id';

  useEffect(() => {
    landingApi.getAcademyCourse(id).then((res) => {
      if (res?.data) setCourse(res.data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return (
      <section style={{ padding: '120px 0', textAlign: 'center' }}>
        <div className="container">
          <p style={{ color: 'var(--text)' }}>Memuat...</p>
        </div>
      </section>
    );
  }

  if (!course) {
    return (
      <section style={{ padding: '120px 0', textAlign: 'center' }}>
        <div className="container">
          <h3>Kursus Tidak Ditemukan</h3>
          <p style={{ color: 'var(--text)', margin: '16px 0 32px' }}>Kursus yang Anda cari tidak tersedia.</p>
          <Link to="/academy" className="btn-action">Kembali ke Akademi</Link>
        </div>
      </section>
    );
  }

  return (
    <div>
      <section style={{ padding: '80px 0 60px', background: 'var(--surface)' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {course.level && (
                  <span style={{
                    fontSize: 12, fontWeight: 700, padding: '4px 14px', borderRadius: 20,
                    background: levelBadge[course.level]?.bg || 'rgba(12,143,134,0.1)',
                    color: levelBadge[course.level]?.color || 'var(--primary)',
                  }}>{levelBadge[course.level]?.label || course.level}</span>
                )}
                {course.category?.name && (
                  <span style={{
                    fontSize: 12, fontWeight: 600, padding: '4px 14px', borderRadius: 20,
                    background: 'var(--primary-light)', color: 'var(--primary)',
                  }}>{course.category.name}</span>
                )}
              </div>
              <h2 style={{ fontSize: 32, marginBottom: 16 }}>{course.title}</h2>
              <p style={{ fontSize: 16, color: 'var(--text)', lineHeight: 1.8, marginBottom: 24 }}>{course.description}</p>
              <div style={{ display: 'flex', gap: 32, marginBottom: 32 }}>
                <div>
                  <div style={{ fontSize: 13, color: 'var(--text)' }}>Pelajaran</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--primary)' }}>{course._count?.lessons || 0}</div>
                </div>
                <div>
                  <div style={{ fontSize: 13, color: 'var(--text)' }}>Peserta</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--primary)' }}>{(course._count?.enrollments || 0).toLocaleString()}</div>
                </div>
              </div>
              {(course.mentor?.fullName || course.mentor?.name) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
                  <div style={{
                    width: 48, height: 48, borderRadius: '50%',
                    background: 'var(--primary-light)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: 'var(--primary)', fontWeight: 700, fontSize: 20,
                  }}>
                    {(course.mentor.fullName || course.mentor.name).charAt(0)}
                  </div>
                  <div>
                    <div style={{ fontSize: 14, color: 'var(--text)' }}>Mentor</div>
                    <div style={{ fontWeight: 600 }}>{course.mentor.fullName || course.mentor.name}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-4">
              <div style={{
                background: 'var(--bg)', borderRadius: 20, padding: 32,
                border: '1px solid var(--line)',
              }}>
                <h5 style={{ marginBottom: 8, fontSize: 20 }}>Ikuti Kursus Ini</h5>
                <p style={{ fontSize: 14, color: 'var(--text)', marginBottom: 24, lineHeight: 1.7 }}>
                  Daftar sekarang dan dapatkan akses ke semua materi pembelajaran.
                </p>
                <a href={FE_WEB_URL} className="btn-action" style={{ width: '100%', textAlign: 'center', padding: '12px 20px', fontSize: 15, display: 'block' }}>
                  Daftar & Mulai Belajar
                </a>
                <Link to="/academy" style={{
                  display: 'block', textAlign: 'center', marginTop: 12,
                  fontSize: 14, color: 'var(--text)', fontWeight: 500,
                }}>← Kembali ke Akademi</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h4 style={{ marginBottom: 24 }}>Materi Pembelajaran</h4>
              <div className="row">
                {(course.lessons || []).map((lesson, i) => (
                  <div className="col-md-6" key={lesson.id || i} style={{ marginBottom: 12 }}>
                    <div style={{
                      display: 'flex', alignItems: 'center', gap: 16,
                      padding: '16px 20px', background: 'var(--surface)',
                      borderRadius: 12, border: '1px solid var(--line)',
                    }}>
                      <div style={{
                        width: 36, height: 36, borderRadius: '50%',
                        background: lesson.isFree ? 'var(--primary-light)' : 'var(--surface)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: lesson.isFree ? 'var(--primary)' : 'var(--text)',
                        fontWeight: 700, fontSize: 14,
                        border: lesson.isFree ? 'none' : '1px solid var(--line)',
                      }}>{lesson.orderIndex + 1}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{lesson.title}</div>
                        <div style={{ fontSize: 13, color: 'var(--text)', display: 'flex', gap: 12, marginTop: 2 }}>
                          {lesson.duration > 0 && <span>{lesson.duration} menit</span>}
                          {lesson.isFree && <span style={{ color: 'var(--primary)', fontWeight: 600 }}>Gratis</span>}
                          {!lesson.isFree && <span>Akses setelah mendaftar</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Sale01 />
    </div>
  );
}

export default AcademyDetail;
